module.exports = __webpack_public_path__ + "img/bg_image_4.3136f516.png";